module.exports = __webpack_public_path__ + "static/media/productionDocumentation.6c3c42d2.yaml";